module.exports = __webpack_public_path__ + "static/media/arrow.0d1adb7d.svg";